import subject from "../topics/Topicts";

const subjects = [
  
    {
      id: 1,
      subject: 'physics',
      name: 'Physics',
      icon: '🪐', // Atom symbol
      color: '#3498db',
    },
    {
      id: 2,
      subject: 'chemistry',
      name: 'Chemistry',
      icon: '⚛️', // Alembic symbol
      color: '#2ecc71',
    },
    {
      id: 3,
      subject: 'biology',
      name: 'Biology',
      icon: '🧬', // DNA symbol
      color: '#9b59b6',
    }
];

export default subjects;